import { createSubject } from "light-observable/observable";
import type { Observable } from "light-observable";
import { onMount } from "svelte";

export function createEvent<T>(name: string) {
    const [eventStream, eventSink] = createSubject<T>();

    const event = eventStream as Observable<T> & {
        trigger: (data: T) => void;
        onMount: (fn: (data: T) => void) => void;
    };
    event.trigger = eventSink.next.bind(eventSink);
    event.onMount = (fn) => {
        onMount(() => {
            const ev = eventStream.subscribe(fn);
            return () => ev.unsubscribe();
        });
    };
    return event;
}
